import React, { ReactNode } from 'react'
import styled, { keyframes } from 'styled-components'
import { mobile } from '../../utils/media-query'

const marquee = keyframes`
    0% {
        transform: translate(0, 0);
    }
    100% {
        transform: translate(-100%, 0);
    }
`

const Container = styled.div`
    display: flex;
    justify-self: flex-start;
    box-sizing: border-box;
    opacity: 0.6;
    padding-left: 20px;

    div {
        display: flex;
        animation: ${marquee} 50s linear infinite;

        & > * {
            margin-right: 50px;

            ${mobile.css`
                margin-right: 20px;
            `}
        }
    }

    ${mobile.css`
        padding-left: 0;
    `}
`

const First = styled.div`
    animation-delay: 1s;
`

const Second = styled.div`
    animation-delay: 52s;
`

type MarqueeProps = {
    children: ReactNode
}
const Marquee = ({ children }: MarqueeProps) => {
    return (
        <Container>
            <First>{children}</First>
            <Second>{children}</Second>
        </Container>
    )
}

export default Marquee
